export const MIN_TILE_SIZE = 16;
export const SNAP_THRESHOLD_PX = 6;
export const DEFAULT_GRID_SIZE = 8;

export const RESIZE_HANDLES = [
  "nw",
  "n",
  "ne",
  "w",
  "e",
  "sw",
  "s",
  "se",
] as const;
